export default "__VITE_ASSET__DoLkQh0W__"